import {gsap, SplitText} from "gsap/all";

gsap.registerPlugin(SplitText);

const div_name = "#big-title-wrapper";
let splittext = null;
let tweens_arrays_apparition = [];
let tweens_arrays_disparition = [];
let nb_tweens_finished = 0;
let nb_tweens_finished_disappear = 0;

/**
 * Créaion du splitext pour la dispaition
 * @param separate_words
 */
const create_split_text_for_disappead = (separate_words = false) => {
    // console.log("CREATE SPLIT TEXT DISPARITION");
    let split_text_type = (separate_words ? "chars, words" : 'chars');
    splittext = new SplitText(div_name + ' p', {
        type: split_text_type,
        charsClass: 'letter',
        wordsClass: 'word',
        position: "absolute"
    });

    // deux animation différente en fonction de si les mots sont séparés
    if(separate_words){
        $.each(splittext.words, function (index, word_el) {
            var letters = $(word_el).children(".letter");
            var staggerDelay = (index % 2 === 0 ? -0.07 : 0.07);
            var disparition_tween;
            if (index === 0) {
                disparition_tween = gsap.to(letters, {
                    y: '-100%',
                    scale: 1.1,
                    ease: "Power3.easeout",
                    stagger: staggerDelay,
                    duration: .8,
                    onComplete: () => {
                        testAllTweenCompleteForDisappear()
                    },
                });
            } else {
                disparition_tween = gsap.to(letters, {
                    y: '-100%',
                    scale: 1.1,
                    ease: "Power3.easeout",
                    stagger: staggerDelay,
                    duration: .8,
                    onComplete: () => {
                        testAllTweenCompleteForDisappear()
                    },
                })
            }
            tweens_arrays_disparition.push(disparition_tween);
        });
    }else {
        var disparition_tween = gsap.to(splittext.chars, {
            y: '-100%',
            scale: 1.1,
            ease: "Power3.easeout",
            stagger: 0.07,
            duration: .8,
            onComplete: () => {
                testAllTweenCompleteForDisappear()
            }
        })
        tweens_arrays_disparition.push(disparition_tween);
    }
}

/**
 * Création du split text pour l'appaition du titre
 */
const create_split_text = (separate_words = false) => {
    // console.log("CREATE SPLIT TEXT");
    //gsap.from(div_name, {autoAlpha:0, y:"+120%"})
    // pour la page d'accueil on a un splittext légèrement différent (avec les mots)
    let split_text_type = (separate_words ? "chars, words" : 'chars');
    splittext = new SplitText(div_name + ' p', {
        type: split_text_type,
        charsClass: 'letter',
        wordsClass: 'word',
        position: "absolute"
    });
    gsap.set(div_name, {alpha:1})


    if (separate_words) {
        // pour chaque mot, on récupère les lettres le composant
        $.each(splittext.words, function (index, word_el) {
            var letters = $(word_el).children(".letter");
            var staggerDelay = (index % 2 === 0 ? -0.07 : 0.07);
            var apparition_tween;
            if (index === 0) {
                apparition_tween = gsap.from(letters, {
                    y: '+120%',
                    scale: 1.1,
                    ease: "Power3.easeout",
                    stagger: staggerDelay,
                    onComplete: () => {
                        testAllTweenComplete()
                    },
                    duration: .85
                });
            } else {
                apparition_tween = gsap.from(letters, {
                    y: '+120%',
                    scale: 1.1,
                    ease: "Power3.easeout",
                    stagger: staggerDelay,
                    onComplete: () => {
                        testAllTweenComplete()
                    },
                    duration: .85
                })
            }
            tweens_arrays_apparition.push(apparition_tween);
        });
    } else {
        var apparition_tween = gsap.from(splittext.chars, {
            y: '+120%',
            scale: 1.1,
            ease: "Power3.easeout",
            stagger: 0.07,
            duration: .85,
            onComplete: () => {
                testAllTweenComplete()
            }
        })
        tweens_arrays_apparition.push(apparition_tween);
    }
}

const testAllTweenComplete = () => {
    let nb_tweens = tweens_arrays_apparition.length;
    nb_tweens_finished++;
    if (nb_tweens_finished >= nb_tweens) {
        splittext.revert();
        nb_tweens_finished = 0;
        // console.log("toutes les tweens sont terminées");
        big_title_desinit()
    }
}

const testAllTweenCompleteForDisappear = () => {
    let nb_tweens = tweens_arrays_disparition.length;
    nb_tweens_finished_disappear++;
    if (nb_tweens_finished_disappear >= nb_tweens) {
        splittext.revert();
        nb_tweens_finished_disappear = 0;
        // console.log("toutes les tweens sont terminées");
        gsap.set(div_name, {alpha:0})
        big_title_desinit()
    }
}

const animationEnterBigTitle = () => {
    // console.log("animationEnterBigTitle");
    $.each(tweens_arrays_apparition, function (index, value) {
        // console.log(value);
        value.play();
    });
}


/**
 * Initialisation
 */
const big_title_init = (separate_word = false) => {
    if ($(div_name).length) {
        create_split_text(separate_word);
    }
}

/**
 * Desinitialisation
 */
const big_title_desinit = () => {
    // console.log("DesInit big title");
    tweens_arrays_disparition = [];
    tweens_arrays_apparition = [];
    $.each(tweens_arrays_apparition, function (index, value) {
        value.eventCallback("onComplete", null);
        value.kill();
    });
    $.each(tweens_arrays_disparition, function (index, value) {
        value.eventCallback("onComplete", null);
        value.kill();
    });
}


//export
export {
    big_title_init,
    big_title_desinit,
    create_split_text_for_disappead,
    animationEnterBigTitle,
    tweens_arrays_apparition,
    tweens_arrays_disparition
};